
import Joi from 'joi';

import { generateJoiValidation } from '@/shared/validations/generateJoiValidation';
import { Notification } from './notification.model';
import { objectId } from '@/shared/validations/custom.validation';

export const createNotification = () => ({
  body: generateJoiValidation(Notification.schema),
});

export const updateNotification = () => ({
  query: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
  body: generateJoiValidation(Notification.schema, true),
});

export const getNotifications = {
  query: Joi.object().keys({
    search: Joi.string(),
    sortBy: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    status: Joi.string(),
    type: Joi.string(),
    userType: Joi.string(),
    includeTimeStamps: Joi.boolean(),
  }),
};

export const getNotificationById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
};

export const deleteNotificationById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
};
